import { useCallback } from 'react';
import { formatCustomerGroup } from '@loomstateorg/shared-frontend/helpers/formatter';

export const ALL_USERS_TAG = 'allUsers';

export const getTagId = (tag: { sys?: { id?: string } } = {}) => tag.sys?.id ?? '';

export const hasMatchingTag = (tags: any[] = [], matchId: string) =>
  tags.some((tag) => {
    const tagId = getTagId(tag);
    return tagId === matchId || tagId === ALL_USERS_TAG;
  });

const usePermissionsChecker = () => {
  const formattedCustomerGroup = useCallback((customerGroup: any) => {
    return formatCustomerGroup(customerGroup?.obj?.key ?? '');
  }, []);

  const isMatchingTag = useCallback((tagId: string, customerGroup: any) =>
    tagId === formattedCustomerGroup(customerGroup) || tagId === ALL_USERS_TAG, [formattedCustomerGroup]);

  const filterByTags = useCallback((items: any[], customerGroup: any) =>
    items?.filter((item) => hasMatchingTag(item?.metadata?.tags, formattedCustomerGroup(customerGroup))), [formattedCustomerGroup]);

  const getFields = useCallback((dataItem: any) => dataItem?.fields, []);

  const checkItemPermission = useCallback((item: any, customerGroup: any) => {
    return !item?.metadata?.tags || hasMatchingTag(item?.metadata?.tags, formattedCustomerGroup(customerGroup));
  }, [formattedCustomerGroup]);

  return { formattedCustomerGroup, getTagId, filterByTags, getFields, checkItemPermission };
};

export default usePermissionsChecker;
